import { eStrings } from '@/constants/strings';
import { twMerge } from '@/utils/tw-merge';

export const Disclaimer = ({ className }: { className?: string }) => {
  return (
    <p
      className={twMerge(
        'style-body-small border-t border-borderline-light py-4 italic text-gray-700',
        className
      )}
    >
      Hoewel bij de samenstelling van de inhoud van {eStrings.LBL_DIGI_V} de
      grootst mogelijke zorgvuldigheid wordt betracht, bestaat de mogelijkheid
      dat bepaalde informatie (na verloop van tijd) verouderd is of om andere
      redenen toch niet correct of volledig is. Er kunnen op geen enkele wijze
      rechten aan {eStrings.LBL_DIGI_V} worden ontleend. De uitvoerende
      omgevingsdienst aanvaardt geen aansprakelijkheid voor de eventuele schade
      die zou kunnen voortvloeien uit het gebruik van gegevens uit{' '}
      {eStrings.LBL_DIGI_V}
    </p>
  );
};
